export const useFormOnKeyDownAvoidEnter = () => {
    return [
        (e) => {
            // @ts-expect-error `type` indeed exists in `target`
            if (e.key === 'Enter' && e.target.type !== 'textarea') {
                e.preventDefault();
                e.stopPropagation();
            }
        }
    ];
};
//# sourceMappingURL=useFormOnKeyDownAvoidEnter.js.map